import React from "react";

function MyProperties({ properties, handleVisitClick }) {
  const purchasedProperties = properties.filter((prop) => prop.saleDetails);

  if (!purchasedProperties || purchasedProperties.length === 0) {
    return (
      <div className="text-center p-6 text-gray-500 text-lg">
        You do not have any purchased properties to display.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
      {purchasedProperties.map((property) => {
        // Address string (multi-line)
        const address = [
          property.project?.address?.streetName1,
          property.project?.address?.streetName2,
          property.project?.address?.city,
          property.project?.address?.district,
          property.project?.address?.state,
          property.project?.address?.country,
        ]
          .filter(Boolean)
          .join(", ");
        // Location
        const location = property.project?.location || property.project?.address?.city || "N/A";
        // Unit (with floor if available)
        let unit = property.unit || property.propertyNo || "N/A";
        if (property.floorNo) {
          unit += `, Floor ${property.floorNo}`;
        }
        // Installments
        const installments = property.installmentsCount || property.installments || "N/A";
        // Next Payment
        const nextPayment = property.nextPaymentDate || property.nextPayment || "N/A";
        return (
          <div
            key={property.propertyId}
            className="bg-white rounded-xl shadow-md p-0 flex flex-col border border-gray-100 max-w-md mx-auto"
            style={{ minWidth: 320 }}
          >
            {/* Card Body (no image) */}
            <div className="p-6 pb-4 flex-1 flex flex-col">
              <h3 className="font-bold text-xl mb-1 text-gray-900">
                {property.project?.projectName || "Property Name"}
              </h3>
              <p className="text-gray-600 text-sm mb-3 whitespace-pre-line">
                {address}
              </p>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-gray-700 text-sm mb-1">
                <span><b>Location:</b> {location}</span>
                <span>|</span>
                <span><b>Unit :</b> {unit}</span>
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-gray-700 text-sm mb-3">
                <span><b>Installments:</b> {installments}</span>
                <span>|</span>
                <span><b>Next Payment :</b> <span className="font-semibold">{nextPayment}</span></span>
                
              </div>
              <button
                className="w-full mt-2 py-3 text-lg font-medium bg-orange-500 text-white rounded-lg shadow hover:bg-orange-600 transition-all"
                onClick={() => handleVisitClick(property)}
              >
                View Details
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default MyProperties;
